module.exports = __webpack_public_path__ + "static/img/310.73827b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/310.png
// module id = 519
// module chunks = 3